import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBContainer,
} from "mdbreact";
import Background from "../assets/images/bg_page.png";
import packkagee from "../../package.json";

export default class Headers extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    collapseID: "",
    pathnamed: null,
  };

  toggleCollapse = (collapseID) => () =>
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : "",
    }));

  render() {
    return (
      <>
        <div
          className="bg-image card shadow-1-strong white-text"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundRepeat: "no-repeat, repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            className="mask pt-3 pb-3 pl-3 pr-3"
            style={{ backgroundColor: "rgba(65, 65, 65, 0.8)" }}
          >
            <div className="d-flex justify-content-center align-items-center h-100">
              <MDBContainer fluid>
                <MDBCard>
                  <MDBCardBody className="#fb8c00 orange darken-1">
                    <MDBCardText>
                      <MDBRow className="text-white">
                        <MDBCol className="text-left" lg="5" md="6" sm="12">
                          <a className="text-white" href={"/" + packkagee.name}>
                            <h4>ระบบรับสมัครนักศึกษา</h4>
                          </a>
                        </MDBCol>
                        <MDBCol className="text-left" lg="2" md="6" sm="12">
                          <a
                            className="text-white"
                            href="https://admission.kpru.ac.th/administrator-system/"
                            target="_blank"
                          >
                            สำหรับผู้ดูแลระบบ | อาจารย์แนะแนว | คณะ
                          </a>
                        </MDBCol>
                        <MDBCol className="text-left" lg="2" md="6" sm="12">
                          <a
                            className="text-white"
                            href="https://admission.kpru.ac.th/onlinescore/#/"
                            target="_blank"
                          >
                            กรอกคะแนนสอบสัมภาษณ์ (เฉพาะกรรมการ)
                          </a>
                        </MDBCol>
                        <MDBCol className="text-left" lg="3" md="6" sm="12">
                          <a
                            className="text-white"
                            href="https://admission.kpru.ac.th/nurse_interviwe2022/"
                            target="_blank"
                          >
                            กรอกคะแนนสอบสัมภาษณ์ (คณะพยาบาลศาสตร์)
                          </a>
                        </MDBCol>
                      </MDBRow>
                    </MDBCardText>
                  </MDBCardBody>
                  <MDBNavbar className="#424242 grey darken-3" dark expand="md">
                    <MDBNavbarToggler onClick={this.toggleCollapse("navbarCollapse3")} />
                    <MDBCollapse id="navbarCollapse3" isOpen={this.state.collapseID} navbar>
                      <MDBNavbarNav left>
                        <MDBNavItem>
                          <a
                            className="nav-link white-text active"
                            href={"/" + packkagee.name}
                            aria-current="page"
                          >
                            หน้าแรก
                          </a>
                        </MDBNavItem>
                        <MDBNavItem>
                          <MDBDropdown>
                            <MDBDropdownToggle nav caret>
                              <span className="mr-2">สมัครเรียนออนไลน์</span>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Register/1"}>
                                ปริญญาตรี ภาคปกติ (จันทร์-ศุกร์)
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Register/2"}>
                                ปริญญาตรี ภาคกศ.บป. (เสาร์-อาทิตย์)
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/select-bundit"}>
                                ระดับบัณฑิตศึกษา (โท-เอก)
                              </MDBDropdownItem>
                              <MDBDropdownItem href={"/" + packkagee.name + "/Register/5"}>
                                ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                              </MDBDropdownItem>
                            </MDBDropdownMenu>
                          </MDBDropdown>
                        </MDBNavItem>
                        <MDBNavItem>
                          <a
                            className="nav-link white-text active"
                            href={"/" + packkagee.name + "/Checkregister/2"}
                            aria-current="page"
                          >
                            ตรวจสอบสถานะ
                          </a>
                        </MDBNavItem>
                        <MDBNavItem>
                          <a
                            className="nav-link white-text active"
                            href={"/" + packkagee.name + "/Tuitionfee"}
                            aria-current="page"
                          >
                            ค่าธรรมเนียมการศึกษา
                          </a>
                        </MDBNavItem>
                        <MDBNavItem>
                          <a
                            className="nav-link white-text active"
                            href={"/" + packkagee.name + "/Checkpresent"}
                            aria-current="page"
                          >
                            กรอกข้อมูลรายงานตัว
                          </a>
                        </MDBNavItem>
                        <MDBNavItem>
                          <MDBDropdown>
                            <MDBDropdownToggle nav caret>
                              <span className="mr-2">หลักสูตรเรียนอะไร/จบแล้วทำอะไร</span>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                              <MDBDropdownItem
                                href="https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru1.asp"
                                target="_blank"
                              >
                                ระดับปริญญาตรี
                              </MDBDropdownItem>
                              <MDBDropdownItem
                                href="https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru2.asp"
                                target="_blank"
                              >
                                ระดับปริญญาโท - เอก
                              </MDBDropdownItem>
                              <MDBDropdownItem
                                href="https://reg.kpru.ac.th/ad_kpru/pages/adcur_kpru3.asp"
                                target="_blank"
                              >
                                ระดับประกาศนียบัตร
                              </MDBDropdownItem>
                            </MDBDropdownMenu>
                          </MDBDropdown>
                        </MDBNavItem>
                        {/* <MDBNavItem>
                        
                      </MDBNavItem> */}
                        <MDBNavItem>
                          <MDBDropdown>
                            <MDBDropdownToggle nav caret>
                              <span className="mr-2">เยี่ยมชมคณะ</span>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                              <MDBDropdownItem href="https://edu.kpru.ac.th/" target="_blank">
                                คณะครุศาสตร์
                              </MDBDropdownItem>
                              <MDBDropdownItem href="https://huso.kpru.ac.th/main/" target="_blank">
                                คณะมนุษยศาสตร์และสังคมศาสตร์
                              </MDBDropdownItem>
                              <MDBDropdownItem href="https://scitech.kpru.ac.th/" target="_blank">
                                คณะวิทยาศาสตร์และเทคโนโลยี
                              </MDBDropdownItem>
                              <MDBDropdownItem href="https://fms.kpru.ac.th/" target="_blank">
                                คณะวิทยาการจัดการ
                              </MDBDropdownItem>
                              <MDBDropdownItem
                                href="https://techno.kpru.ac.th/techno/"
                                target="_blank"
                              >
                                คณะเทคโนโลยีอุตสาหกรรม
                              </MDBDropdownItem>
                              <MDBDropdownItem href="https://nurse.kpru.ac.th/" target="_blank">
                                คณะพยาบาลศาสตร์
                              </MDBDropdownItem>
                              <MDBDropdownItem href="https://maesot.kpru.ac.th/th/" target="_blank">
                                มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด
                              </MDBDropdownItem>
                              <MDBDropdownItem href="http://graduates.kpru.ac.th/" target="_blank">
                                บัณฑิตวิทยาลัย
                              </MDBDropdownItem>
                            </MDBDropdownMenu>
                          </MDBDropdown>
                        </MDBNavItem>
                        <MDBNavItem>
                          <a
                            className="nav-link white-text active"
                            href="https://arit.kpru.ac.th/page_id/406/TH"
                            aria-current="page"
                            target="_blank"
                          >
                            แผนผังมหาวิทยาลัยราชภัฏกำแพงเพชร
                          </a>
                        </MDBNavItem>
                      </MDBNavbarNav>
                    </MDBCollapse>
                  </MDBNavbar>
                </MDBCard>
                <br />
                <br />

                <div id="pageintro" className="hoc clear">
                  <article>
                    <h1 className="heading">มหาวิทยาลัยราชภัฏกำแพงเพชร</h1>
                    <p>
                      เปิดรับสมัครนักศึกษาใหม่ <span className="style4">ประจำปีการศึกษา 2569</span>
                    </p>
                    {/* ภาคปกติ - ภาคกศ.บป. &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706547" target="_blank">(055) 706 547 </a>| <a className="text-white style4" href="https://www.facebook.com/kpru.register" target="_blank">Facebook</a><br />
                  ปริญญาโท - ปริญญาเอก &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706555" target="_blank">(055) 706 555 ต่อ 1770, 1780 </a>| <a className="text-white style4" href="https://www.facebook.com/graduateskpru/" target="_blank">Facebook</a><br />
                  ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู &nbsp;<i className="fa fa-phone style4"></i>&nbsp;&nbsp;&nbsp;<a className="text-white style4" href="tel:055706555" target="_blank">(055) 706 555 ต่อ 2010 </a>| <a className="text-white style4" href="https://www.facebook.com/edukpru/" target="_blank">Facebook</a> */}
                  </article>
                </div>
              </MDBContainer>
            </div>
          </div>
        </div>
      </>
    );
  }
}
